/**
 * @generated SignedSource<<dd096cae0a2336de19d18b4edc60059a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemLocationInfo_item$data = {
  readonly ilEvent: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly ilFolders: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  };
  readonly ilSpace: {
    readonly color: {
      readonly dark: string;
      readonly light: string;
    };
    readonly id: string;
    readonly name: string;
  };
  readonly " $fragmentType": "ItemLocationInfo_item";
};
export type ItemLocationInfo_item$key = {
  readonly " $data"?: ItemLocationInfo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemLocationInfo_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemLocationInfo_item",
  "selections": [
    {
      "alias": "ilSpace",
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "ownershipSpace",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Color",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "light",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dark",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "ilEvent",
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "ownershipEvent",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": "ilFolders",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "FolderConnection",
      "kind": "LinkedField",
      "name": "ownershipFolders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Folder",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "ownershipFolders(first:1)"
    }
  ],
  "type": "HasOwnerPermissionsInterface",
  "abstractKey": "__isHasOwnerPermissionsInterface"
};
})();

(node as any).hash = "789ab2fb2d5e963a4eeec17b4eaab0c2";

export default node;
